import TopBarProgress from 'react-topbar-progress-indicator';

/**
 * Configure and Initialize the TopBarProgress component
 */

TopBarProgress.config({
    barColors: {
        1: '#078CDD',
        '1.0': '#078CDD',
    },
    shadowBlur: 5,
});

export default TopBarProgress;
